"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
function extendStyles(sourceStyles, partialStyles) {
    var styles = (0, tslib_1.__assign)({}, sourceStyles);
    Object.keys(partialStyles).forEach(function (styleName) {
        styles[styleName] = styles[styleName]
            ? (0, classnames_1.default)(styles[styleName], partialStyles[styleName])
            : partialStyles[styleName];
    });
    return styles;
}
exports.default = extendStyles;
//# sourceMappingURL=extendStyles.js.map